<app-dashboard>
  <div
    class="w-full flex flex-col gap-[30px] justify-center p-[20px]"
  >
    <div class="w-full flex justify-end">
      <app-button
        [label]="'New Customer'"
        (onClick)="openCreateModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
    <app-table
    [tableData]="tableData"
    [tableHeader]="tableHeader"
    (rowClick)="navigateTo($event)"
    [tableTitle]="'Transactions'"
    [loading]="fetchingData"
    [emptyState]="emptyTableState"
    [filterData]="filterData"
    (handleFilter)="applyFilter($event)"
    (handleSearch)="search($event)"
    [tableWidth]="' min-w-[990px]'"
    [toolbar]="{
      paginate: true,
      search: true,
      filter: true,
      addnew: false
    }"
    [paginationData]="{
      limit: limit,
      totalData: totalCustomers
    }"
    (changeLimit)="changeLimit($event)"
  >
  <!-- (switch) -->
    <div class="flex justify-end items-center sm:w-full">
      <app-pagination
        *ngIf="
          !fetchingData && this.totalCustomers > 0
        "
        [totalItems]="this.totalCustomers"
        [(pageSize)]="this.limit"
        [(currentPage)]="this.page"
        (pageSizeChange)="this.refreshList()"
        (currentPageChange)="this.getCustomers()"
      ></app-pagination>
    </div>
  </app-table>
    <!-- <app-table [headers]="headers" [data]="tableData" [columnWidths]="columnWidths"></app-table> -->
    <!-- <div class="w-full flex flex-col gap-[10px]">
      <div
      *ngFor="let customer of customers"
        style="box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1)"
        (click)="openViewModal()"
        class="w-full flex cursor-pointer items-center justify-between rounded-[10px] px-[12px] py-[8px]"
      >
        <div class="grid grid-cols-2 items-center w-full">
          <div class="flex items-center gap-[20px]">
            <img src="../../../assets/icons/avatar-2.svg" alt="" />
            <div class="flex flex-col">
              <span class="text-[18px] font-[800] text-slate-800"
                >{{customer?.fullName}}</span
              >
              <span class="text-[12px] font-[600] text-slate-500"
                >{{customer?.emailAddress}}</span
              >
            </div>
          </div>
          <span class="font-[700] text-slate-800">{{customer?.phoneNumber}}</span>
        </div>
        <img src="../../../assets/icons/chevron-right1.svg" alt="" />
      </div>
    </div> -->
  </div>
</app-dashboard>
<app-modal
  [isOpen]="createModalOpen"
  (closeModalEvent)="closeCreateModal()"
  [title]="'Create New Customer'"
>
  <div class="w-full flex flex-col">
    <app-input [label]="'User Identifier'" [placeholder]="'0000000'" (returnValue)="handleInput($event)" [error]="errors.userIdentifier" [title]="'userIdentifier'" />
    <app-input [label]="'Full Name'" [placeholder]="'Enter full name'" (returnValue)="handleInput($event)" [error]="errors.fullName" [title]="'fullName'" />
    <div class="w-full flex flex-col sm:grid sm:gap-[20px] sm:grid-cols-2">
      <app-input [label]="'Email Address'" [placeholder]="'Enter email address'" (returnValue)="handleInput($event)" [error]="errors.emailAddress" [title]="'emailAddress'" />
      <app-input [label]="'Phone Number'" [placeholder]="'Enter phone number'" (returnValue)="handleInput($event)" [error]="errors.phoneNumber" [title]="'phoneNumber'" />
    </div>
    <app-text-area [label]="'Additional Data'" [placeholder]="'Enter additional data'" (returnValue)="handleInput($event)" [error]="errors.metaData.data" [title]="'data'" />
  </div>
  <app-button
        [label]="'Create Customer'"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
</app-modal>

